<template>
  <LayoutDefault>

    <section v-if="prematriculaLoading" class="fuid-resu__loading">
      <b-row>
        <b-col cols="12" class="fuid-form-to-render">
          <h4 class="fuid-resu-tit text-center">{{ $t('resume.tit0') }}</h4>
          <p class="text-center pt-3">{{ $t('resume.stit0') }}</p>
          <div class="text-center p-3">
            <b-spinner label="Loading..."></b-spinner>
          </div>
        </b-col>
      </b-row>
    </section>

    <section v-else>
      <b-row>
        <b-col cols="12" class="fuid-form-to-render">
          <h4 class="fuid-resu-tit">{{ $t('resume.tit1') }}</h4>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <div v-for="(alumno, index) in getPrematriculaAlumnos" :key="index" class="fuid-resu__pupilc">
            <b-row>
              <b-col cols="12" lg="4" class="fuid-resu__pupil">
                <h4>{{ alumno.name }}</h4>
                <p v-if="alumno.dni">{{ $t('resume.dni') }}: <strong>{{ alumno.dni }}</strong></p>
              </b-col>

              <b-col cols="12" lg="8">
                <div v-for="(select, indexp) in selectsByAlumno(alumno.id)" :key="indexp" class="">
                  <div v-if="select.nivel"
                    class="d-flex flex-wrap flex-lg-nowrap justify-content-between align-items-center mb-2">
                    <div class="fuid-resu__lang">
                      <strong class="inline-block pr-2 pt-2">
                        {{ $t(`languages.${select.tCode}`) }}
                      </strong> | <span class="pl-2 pt-2">
                        {{ select.nivelLabel }}
                      </span>
                    </div>

                    <groupSelect :id="select.id" :options="select.options" :error="select.error"
                      @changeSelect="groupChange" @emptySelect="emptySelect" />
                  </div>

                  <div v-else class="d-flex justify-content-start align-items-center">
                    <strong class="inline-block pr-2">{{ select.nivelNombre }}</strong>
                    <span class="inline-block">{{ $t('forms.nolevel') }}</span>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row class="fuid-form-to-render">
        <b-col cols="12">
          <h4 class="fuid-resu-tit">{{ $t('resume.tit2') }}</h4>
        </b-col>

        <b-col cols="12" class="fuid-resu__pupilc">
          <b-row>
            <b-col cols="12" lg="12" class="fuid-resu__pupil no-border">
              <h4>{{ solicitante.nombre }}</h4>
              <p>{{ $t('resume.dni') }}: <strong>{{ solicitante.dni }}</strong></p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row class="fuid-form-to-render">
        <b-col cols="12">
          <h4 class="fuid-resu-tit">{{ $t('payment.tit') }}</h4>
        </b-col>

        <b-col cols="12 fuid-payment__options pt-3">
          <b-form-group :label="$t('payment.tit')">
            <b-form-radio-group size="lg" :options="paymentOptions" @change="paymentTypeChange" name="payment-type"
              stacked></b-form-radio-group>
          </b-form-group>

          <div>
            <b-modal id="modalPaymentType" v-model="modalPaymentType" :title="$t('paymentt.2')"
              :no-close-on-backdrop="true" ok-only centered>
              <template v-slot:modal-header>
                <h5>{{ $t('paymentt.2') }}</h5>
              </template>

              <p v-html="$t('paymentt.modaltxt')"></p>

              <template v-slot:modal-footer="{ ok }" class="justify-content-center">
                <button class="fuid-button fuid-button-step align-items-center" @click="ok()">
                  <span>{{ $t('forms.understood') }}</span>
                </button>
              </template>
            </b-modal>
          </div>
        </b-col>

        <b-col cols="12 fuid-payment__options">
          <b-form-group :label="$t('payment.tit2')" v-if="fields.paymentType == 1">
            <b-form-radio v-for="(method, index) in paymentMethod" :key="index" v-model="fields.paymentMethod"
              name="payment-method" size="lg" :value="method.value.id">{{ method.text }}</b-form-radio>
          </b-form-group>

          <b-form-group :label="$t('payment.tit2')" v-else>
            <b-form-radio v-model="fields.paymentMethod" name="payment-method" size="lg"
              :value="paymentMethod[1].value.id">{{ paymentMethod[1].text }}</b-form-radio>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row v-if="fields.paymentMethod == 2">
        <b-col cols="12 d-lg-flex align-items-end">
          <div class="fuid-iban_group w20">
            <label class="fuid-form__label">{{ $t('payment.entidad') }}</label>
            <input class="fuid-form__input" maxlength="4" v-model="fields.iban_entidad" />
          </div>

          <div class="fuid-iban_group w20">
            <label class="fuid-form__label">{{ $t('payment.sucursal') }}</label>
            <input class="fuid-form__input" maxlength="4" v-model="fields.iban_sucursal" />
          </div>

          <div class="fuid-iban_group w10">
            <label class="fuid-form__label">{{ $t('payment.dc') }}</label>
            <input class="fuid-form__input" maxlength="2" v-model="fields.iban_dc" />
          </div>

          <div class="fuid-iban_group">
            <label class="fuid-form__label">{{ $t('payment.cuenta') }}</label>
            <input class="fuid-form__input" maxlength="10" v-model="fields.iban_cuenta" />
          </div>
        </b-col>

        <b-col v-if="iban && !$v.iban.ibanv" class="form-group--error pt-2">
          <div class="error">{{ $t('forms.iban') }}</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col v-if="totalPrice != 0" cols="12 fuid-form__actions pb-5">
          <b-row>
            <b-col cols="12">
              <h4 class="fuid-resu-tit">{{ $t('resume.tit3') }}</h4>
            </b-col>

            <b-col cols="12 mt-4">
              <div v-for="(alumno, index) in getMatriculaAlumnos" :key="index" class="">
                <div class="d-lg-flex fuid-resu__row">
                  <div class="fuid-resu__alumno pr-3 d-block">
                    {{ alumno.name }}
                  </div>

                  <div class="fuid-resu__data">
                    <div v-for="(matricula, indexm) in alumno.matriculas" :key="indexm"
                      class="d-lg-flex justify-content-lg-between">

                      <div class="fuid-resu__groupre"><strong>{{ $t(`languages.${matricula.tCode}`)
                      }}:</strong> <span class="pr-2">{{ matricula.nivelName }}</span>|<span
                          v-if="$i18n.locale == 'eu'" class="pl-2">{{ matricula.infoeu
                          }}</span><span v-else class="pl-2">{{ matricula.info }}</span></div>

                      <div v-if="fields.paymentType == 2" class="fuid-resu__groupre"><strong>{{
                        getPriceWithIncrement(matricula.price, matricula.horasSemanales) }}</strong><span>€</span></div>
                      <div v-else class="fuid-resu__groupre"><strong>{{ matricula.price
                      }}</strong><span>€</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>

            <b-col cols="12 mt-4">
              <div class="d-lg-flex justify-content-lg-end pt-4 fuid-resu__total">
                <div><strong>{{ $t('payment.total') }}</strong>:
                  <strong>{{ totalPrice }}</strong><span>€</span>
                </div>
              </div>

              <totalInfo v-if="!$isMobile()" :total="totalPrice" :paymentType="fields.paymentType" />
            </b-col>

            <b-col cols="12 mt-4">
              <div v-if="fields.paymentType" class="d-lg-flex justify-content-lg-end pt-2 fuid-resu__total">
                <div class="fuid-resu__payop">{{ $t('payment.payform') }}: <strong>{{
                  $t(`paymentt.${fields.paymentType}`) }}</strong></div>
              </div>

              <div v-if="fields.paymentMethod" class="d-lg-flex justify-content-lg-end mt-2 pt-2 fuid-resu__total">
                <div class="fuid-resu__payop">{{ $t('payment.paymethod') }}: <strong>{{
                  $t(`payment.${fields.paymentMethod}`) }}</strong></div>
              </div>

              <div v-if="iban" class="d-lg-flex justify-content-lg-end mt-2 pt-2 fuid-resu__total">
                <div class="fuid-resu__payop">IBAN: <strong>{{ iban }}</strong></div>
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col class="12 pt-4">
          <div v-if="$v.$error && !$v.totalPrice.minValue" class="form-group--error pt-2">
            <div class="error error-pill">{{ $t('forms.groups') }}</div>
          </div>

          <div v-if="$v.$error && !$v.fields.paymentMethod.minValue" class="form-group--error pt-2">
            <div class="error error-pill">{{ $t('forms.payment') }}</div>
          </div>

          <div v-if="$v.$error && !$v.fields.paymentType.minValue" class="form-group--error pt-2">
            <div class="error error-pill">{{ $t('forms.paymenttype') }}</div>
          </div>

          <div v-if="$v.$error && iban && !$v.iban.ibanv" class="form-group--error pt-2">
            <div class="error error-pill">{{ $t('forms.iban') }}</div>
          </div>

          <div v-if="$v.$error && !iban && fields.paymentMethod == 2" class="form-group--error pt-2">
            <div class="error error-pill">{{ $t('forms.ibannull') }}</div>
          </div>
        </b-col>

        <b-col cols="12" class="fuid-form__actions pb-4 mb-4">
          <matriculaPay :amount="totalPrice" :valid="valid" :paymentMethod="fields.paymentMethod"
            @validateForm="validateForm" @seatsCheck="seatsCheck" />
        </b-col>
      </b-row>
    </section>
  </LayoutDefault>
</template>

<script>

import httpClient from '@/api/httpClient'

import store from '@/store'
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'

import IBAN from 'iban'

import ibanv from '@/mixins/validatorIban'
import priceIncrement from '@/mixins/priceIncrement'
import { required, minValue } from "vuelidate/lib/validators"

import LayoutDefault from '@/components/layouts/LayoutDefault'
import totalInfo from '@/components/totalInfo'
import groupSelect from '@/components/groupSelect'
import matriculaPay from '@/components/matriculaPay'

export default {

  data() {

    return {

      id: 2,
      prematriculaLoading: true,
      loading: false,
      modalPaymentType: false,
      selected: null,
      curso: false,
      valid: {
        n: 0,
        value: false
      },
      f: {},
      groups: false,
      groups_selected: [],
      persona: null,
      prematricula: false,
      fields: {
        paymentType: 0,
        paymentMethod: 0,
        iban: null,
        iban_pais: '',
        iban_entidad: '',
        iban_sucursal: '',
        iban_dc: '',
        iban_cuenta: ''
      },
      paymentOptions: [
        { text: this.$i18n.t("payment.unico"), value: { id: 1, name: "unico" } },
        { text: this.$i18n.t("payment.fraccionado"), value: { id: 2, name: "fraccionado" } },
      ],
      paymentMethod: [
        { text: this.$i18n.t("payment.1"), value: { id: 1, name: "tpv" } },
        { text: this.$i18n.t("payment.2"), value: { id: 2, name: "iban" } },
      ],
      locale: this.$i18n.locale

    }

  },

  validations() {

    if (this.fields.paymentMethod == 2) {

      this.f = {

        iban: {
          required,
          ibanv,
        },
        totalPrice: {
          required,
          minValue: minValue(1)
        },
        fields: {
          paymentMethod: {
            required,
            minValue: minValue(1)
          },
          paymentType: {
            required,
            minValue: minValue(1)
          }
        }

      }

    } else {

      this.f = {

        iban: {

        },
        totalPrice: {
          required,
          minValue: minValue(1)
        },
        fields: {
          paymentMethod: {
            required,
            minValue: minValue(1)
          },
          paymentType: {
            required,
            minValue: minValue(1)
          }
        }

      }

    }

    return this.f

  },

  components: {

    LayoutDefault,
    totalInfo,
    groupSelect,
    matriculaPay

  },

  mixins: [priceIncrement],

  computed: {

    ...mapGetters('Login', ['getUser']),
    ...mapGetters('Login', ['getSolicitanteId']),
    ...mapGetters('Groups', ['getGroupsByNivelId']),
    ...mapGetters('Groups', ['getGroupsById']),
    ...mapGetters('Prematriculas', ['getCursoActual']),
    ...mapGetters('Prematriculas', ['getPrematricula']),
    ...mapGetters('Prematriculas', ['getPrematriculaAlumnos']),
    ...mapGetters('Prematriculas', ['getPrematriculaSolicitante']),
    ...mapGetters('Prematriculas', ['getSelectsByAlumno']),
    ...mapGetters('Prematriculas', ['getGroupIncrement']),
    ...mapGetters('Prematriculas', ['getGroupIncrement2']),
    ...mapGetters('Prematriculas', ['getLocale']),
    ...mapGetters('Localizaciones', ['getLocalizacion']),
    ...mapGetters('Matricula', ['getMatriculaAlumnos']),
    ...mapGetters('Matricula', ['getMatriculaTotal']),

    /**
     * Generate IBAN from form fields
     *
     */

    iban: function () {

      if (this.fields.iban_entidad != '' && this.fields.iban_sucursal != '' && this.fields.iban_dc != '' && this.fields.iban_cuenta != '') {


        try {

          // let bban = this.fields.iban_pais + this.fields.iban_entidad + this.fields.iban_sucursal + this.fields.iban_dc + this.fields.iban_cuenta
          let bban = this.fields.iban_entidad + this.fields.iban_sucursal + this.fields.iban_dc + this.fields.iban_cuenta

          // let iban = 'ES' + bban
          return bban

        } catch (error) {

          return false

        }

      } else {

        return false

      }

    },

    /**
     * Calculate the total price to pay from the selected groups
     *
     */

    totalPrice: function () {

      let total = 0

      this.groups_selected.forEach(g => {

        let group_price

        if (this.fields.paymentType === 2) {

          group_price = g.group.precioIncrementado

        } else {

          group_price = g.group.precio

        }

        total += group_price

      })

      this.setTotal(total)

      return total

    },

    /**
     * Calculate the total price to pay from the selected groups
     *
     */

    solicitante: function () {

      return this.getPrematriculaSolicitante

    },

  },

  methods: {

    ...mapActions('Groups', ['getGroupsByCourse']),
    ...mapActions('Prematriculas', ['getPrematriculaByPersona']),
    ...mapActions('Prematriculas', ['generateSelectData']),
    ...mapActions('Prematriculas', ['selectsSetsErrors']),
    ...mapActions('Prematriculas', ['getCurso']),
    ...mapActions('Localizaciones', ['fetchLocalizacion']),
    ...mapActions('Prematriculas', ['changePriceInSelects']),
    ...mapActions('Prematriculas', ['resetPremasState']),
    ...mapActions('Matricula', ['setTotal']),
    ...mapActions('Matricula', ['addMatriculaAlumno']),
    ...mapActions('Matricula', ['removeMatriculaAlumno']),
    ...mapActions('Matricula', ['setIban']),
    ...mapActions('Matricula', ['setPagoTipo']),
    ...mapActions('Matricula', ['setPagoMetodo']),
    ...mapActions('Matricula', ['setTotal']),

    /**
     * Check valid data
     *
     */

    validateForm(data) {

      this.$v.$touch()

      if (this.$v.$invalid) {

        this.valid.value = false
        this.valid.n = data.value

      } else {

        // Set iban to matricula store
        let ibanMatricula = {
          pais: "",
          paisDC: this.fields.iban_pais,
          entidad: this.fields.iban_entidad,
          sucursal: this.fields.iban_sucursal,
          dc: this.fields.iban_dc,
          cuenta: this.fields.iban_cuenta
        }

        this.setIban(ibanMatricula)

        // Set tipo & metodo to matricula store
        this.setPagoTipo(this.fields.paymentType)
        this.setPagoMetodo(this.fields.paymentMethod)

        // Set total to matricula store
        this.setTotal(this.totalPrice)

        this.valid.value = true
        this.valid.n = data.value

      }

    },

    /**
     * Payment method change
     *  @param value String
     */

    paymentTypeChange(value) {

      this.fields.paymentType = value.id

      // Show the modal with the warning

      if (value.id == 2) {

        this.modalPaymentType = true

      }

      // Hide the IBAN option if Tpv

      if (value.id == 2 && this.fields.paymentMethod == 2) {

        this.fields.paymentMethod = null

      }

      // Reset IBAN

      if (value.id == 1) {

        this.fields.iban_pais = ''
        this.fields.iban_entidad = ''
        this.fields.iban_sucursal = ''
        this.fields.iban_dc = ''
        this.fields.iban_cuenta = ''

      }

      // Change the price in the selects
      this.setPagoTipo(this.fields.paymentType)
      this.changePriceInSelects({ paymentType: this.fields.paymentType, increment: this.getGroupIncrement, increment2: this.getGroupIncrement2 })

    },

    /**
    * Generate the options for the selection of groups by nivel
    *  @param nivelId Number
    */

    selectsByAlumno(id) {

      return this.getSelectsByAlumno(id)

    },

    /**
     * Put the group selected in selected groups when the select change
     *  @param value Object
     */

    groupChange(value) {

      if (value != null) {

        // To calculate the total price by payment method
        let gid = `${value.alumno}${value.id}`
        let gr = this.getGroupsById(value.group_id)

        let group = {
          id: gid,
          alumno: value.alumno,
          group: gr[0]
        }

        let exists = this.groups_selected.find(g => g.id === gid)

        if (typeof exists !== 'undefined') {

          let index = this.groups_selected.indexOf(exists)
          this.groups_selected.splice(index, 1)

        }

        this.groups_selected.push(group)

        // To matricula store for later use
        let alumnoMatricula = {

          id: value.alumno,
          name: value.alumno_nombre,
          matricula: { nivel: value.id, group: value.group_id, price: value.price, info: value.info, infoeu: value.infoeu, idioma: gr[0].nivel.idioma.nombre, tCode: value.tCode, nivelName: value.nivel, horasSemanales: value.horasSemanales }

        }

        this.addMatriculaAlumno(alumnoMatricula)

      }

    },

    /**
     * Remove the group selected in selected groups when the select is empty
     *  @param id Number
     */

    emptySelect(id) {

      let exists = this.groups_selected.find(g => g.id === id)

      if (typeof exists !== 'undefined') {

        let index = this.groups_selected.indexOf(exists)
        this.groups_selected.splice(index, 1)

        // Update alumno in matricula store
        /*
        let alumnoMatricula = {
            id: exists.alumno,
            nivel: exists.group.nivel.id
        }*/

        // this.removeMatriculaAlumno( alumnoMatricula )

      }

    },

    /**
     * Mark the groups width no seats avaliables
     *  @param data Object
     */

    seatsCheck(data) {

      this.selectsSetsErrors({ grupos: data.ids })

    }

  },

  async created() {
    let reset = this.resetPremasState()

    if (reset) {
      this.curso = await this.getCurso({ componentId: this.id })
      this.persona = this.getSolicitanteId
      this.prematricula = await this.getPrematriculaByPersona({ personaId: this.persona, curso: this.getCursoActual.id, componentId: this.id })

      let parts = this.getPrematricula.localizacion.nombre.split('-')
      let slug = parts.shift()
      await this.fetchLocalizacion(`prematriculas-${slug.toLowerCase()}`)

      this.groups = await this.getGroupsByCourse({ idCurso: this.getCursoActual.id, page: 1, idLocalizacion: this.getLocalizacion[0].id, componentId: this.id })

      let selects = await this.generateSelectData()
      if (selects) {
        this.prematriculaLoading = !this.prematricula
      }
    }

    // Custom messages on paymentMethods depending on the prematricula fase
    this.paymentMethod[0].text += (this.getPrematricula.fase !== 3) ? (" " + this.$i18n.t("payment.sub_1")) : "";
    this.paymentMethod[1].text += (this.getPrematricula.fase !== 3) ? (" " + this.$i18n.t("payment.sub_2", { adelanto: this.getPrematricula.curso.adelanto })) : "";
  },

  watch: {

    // When the locale change this change the texts of the radio buttons
    getLocale: function (value) {

      this.paymentOptions[0].text = this.$i18n.t("payment.unico")
      this.paymentOptions[1].text = this.$i18n.t("payment.fraccionado")

      this.paymentMethod[0].text = (this.$i18n.t("payment.1") + ((this.getPrematricula.fase != 3) ? (" " + this.$i18n.t("payment.sub_1")) : ""));
      this.paymentMethod[1].text = (this.$i18n.t("payment.2") + ((this.getPrematricula.fase != 3) ? (" " + this.$i18n.t("payment.sub_2", { adelanto: this.getPrematricula.curso.adelanto })) : ""));

    }

  }

}

</script>
